<script setup lang="ts">
import { useAuth } from '@clerk/vue'
import { watch } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()
const { isLoaded, isSignedIn } = useAuth()

watch([isLoaded, isSignedIn], ([loaded, signedIn]) => {
  if (loaded && !signedIn) {
    router.replace('/sign-in')
  }
}, { immediate: true })
</script>

<template>
  <!-- Loading state while Clerk initializes -->
  <div v-if="!isLoaded" class="min-h-screen bg-surface flex items-center justify-center">
    <div class="animate-sync-pulse text-text-muted font-label text-label-md uppercase tracking-[0.05em]">
      Loading...
    </div>
  </div>

  <!-- Not signed in -->
  <div v-else-if="!isSignedIn" class="min-h-screen bg-surface flex items-center justify-center">
    <div class="text-text-muted font-label text-label-md uppercase tracking-[0.05em]">
      Redirecting to sign in...
    </div>
  </div>

  <!-- Wizard layout: full-screen centered, no sidebar -->
  <div v-else class="min-h-screen bg-surface flex items-center justify-center">
    <div class="w-full max-w-[640px] px-md sm:px-lg py-xl sm:py-2xl">
      <slot />
    </div>
  </div>
</template>
